import gql from "graphql-tag";

export const GET_NOT_AUTHORIZED_LIST = gql`
  query notAuthorizedList {
    notAuthorizedList {
      prefixName
      lastName
      firstName
      middleName
      nameSuffix
      orgUnit
      jobClass
      recordCount
      employee
      _id
    }
  }
`;
